import React, {useMemo} from 'react';
import {ColorPalette} from 'theme';
import {Layout} from 'components/layout';

type Props = {
  spacing?: string | number;
  height?: string | number;
  colorx?: string;
};

const makeBorder = (colorx: string) => `0.5px solid ${colorx}`;

export const Bar: React.FC<Props> = ({spacing, height, colorx}) => {
  const sx = useMemo(() => {
    return colorx
      ? {
          border: makeBorder(colorx),
        }
      : {
          border: makeBorder(ColorPalette.warmGreen),
        };
  }, [colorx]);

  return (
    <Layout
      mx={spacing}
      height={height}
      flex={height === undefined ? 1 : undefined}
      sx={sx}
    />
  );
};
